export const SCHEMA_STORE_NAME = 'indexed_database_schemas';
